(function () {
  'use strict';

  // AJAX layer for native Shopify-faceted-filter pages (Sealed, Graded, etc.).
  //
  // The Empire theme ships a `FacetedFilterCollection` JS class that is
  // SUPPOSED to handle filter clicks via fetch + section swap, but the
  // section-bootstrap path doesn't actually instantiate it on Mangano's
  // build (`window.Theme` exposes only `version` / `name` / `routes`).
  // Rather than untangle the theme's webpack bundle, this script does the
  // job directly using Shopify's Section Rendering API:
  //
  //   GET /<original-url>?section_id=<sectionId>  →  HTML for that section
  //   Swap into #shopify-section-<sectionId>; pushState the URL.
  //
  // Singles uses our own JS filter (see assets/singles-filter.js) so this
  // script intentionally only mounts on pages where the main section is
  // `static-collection-faceted-filters` — i.e. Sealed and Graded.

  var SECTION_TYPE = 'static-collection-faceted-filters';
  var sectionId = null;

  // Live pixel offset used to park the search/sort bar near the top of the
  // viewport after a filter/sort. The product masthead is hidden on these
  // pages, so .collection-search-wrapper is the first content; we land it just
  // below where the header sits. We only RESERVE the header's height when the
  // header is actually sticky/fixed (then it overlaps content) — with the
  // current non-sticky header (sticky_header off) it scrolls away, so we just
  // leave a small breathing gap. Measured live rather than via --header-height
  // (that var is only set by the homepage slideshow JS, so it's unset here).
  function stickyHeaderOffset() {
    var GAP = 16;
    var h = document.querySelector('.site-header');
    if (h) {
      var pos = getComputedStyle(h).position;
      if (pos === 'sticky' || pos === 'fixed') {
        return Math.round(h.getBoundingClientRect().height) + GAP;
      }
    }
    return GAP;
  }

  function init() {
    var sectionDataScript = document.querySelector('script[data-section-type="' + SECTION_TYPE + '"][data-section-data]');
    if (!sectionDataScript) return;
    sectionId = sectionDataScript.getAttribute('data-section-id');
    if (!sectionId) return;

    // Expose for collection-search.liquid's sort handler to call instead of
    // its current `location.href = ...`.
    window.NativeFilterAjax = { navigate: navigate, sectionId: sectionId };

    // Capture-phase delegation so we run BEFORE the link's default navigation
    // and BEFORE any later-bound bubble-phase handlers (e.g. the sort
    // dropdown's existing handler in collection-search.liquid).
    document.addEventListener('click', onDocumentClick, true);

    // Browser back/forward — re-fetch the section for the popped URL.
    window.addEventListener('popstate', function () {
      navigate(location.pathname + location.search, sectionId, /* skipPushState */ true);
    });

    // Empire's FilterGroups class (empire.min.js) runs at page-load time and
    // can call _openAllGroups() / _openFirst() based on the theme's
    // filter_groups setting, applying `productgrid--sidebar-button-active`
    // to buttons we explicitly rendered as closed (and morphing the chevron
    // into a minus sign while the content stays hidden by our inline
    // display:none — a visual mismatch). Restore the Liquid-rendered
    // intended state after Empire has had its turn. The snippet stamps
    // `data-mangano-initial-state="open|closed"` on each trigger for us
    // to read.
    //
    // Fire across multiple ticks because Empire's section bootstraps can
    // run later than DOMContentLoaded. RAF + window.load covers the common
    // cases; the reconciler is idempotent so repeat calls are cheap.
    requestAnimationFrame(reconcileInitialFilterGroupState);
    if (document.readyState !== 'complete') {
      window.addEventListener('load', reconcileInitialFilterGroupState);
    }
  }

  // Re-apply the markup's intended open/closed state to every filter group.
  // Idempotent: runs once on init (after Empire), and is safe to call again.
  function reconcileInitialFilterGroupState() {
    var triggers = document.querySelectorAll('[data-filter-group-trigger][data-mangano-initial-state]');
    triggers.forEach(function (trigger) {
      var shouldBeOpen = trigger.getAttribute('data-mangano-initial-state') === 'open';
      var group = trigger.closest('.collection-filters__filter-group');
      var list = group && (group.querySelector('[data-filter-group-list]') ||
                           group.querySelector('.collection-filters__price-range-form'));
      trigger.setAttribute('aria-expanded', shouldBeOpen ? 'true' : 'false');
      trigger.classList.toggle('productgrid--sidebar-button-active', shouldBeOpen);
      if (list) {
        list.classList.toggle('filter-group-active', shouldBeOpen);
        list.setAttribute('data-accordion-state', shouldBeOpen ? 'open' : 'closed');
        list.style.display = shouldBeOpen ? '' : 'none';
      }
    });
  }

  function onDocumentClick(e) {
    // Accordion toggle on filter group headings (Series / Set / etc.).
    // Empire's FilterGroups class also binds click handlers on these
    // buttons AND may pre-open some groups via _init() depending on the
    // theme's filter_groups setting — so trusting aria-expanded for the
    // toggle direction can desync with what's actually visible. We read
    // the LIST'S actual computed visibility instead, which guarantees
    // a click always inverts the visible state, regardless of any
    // state-mismatch Empire left behind on construction.
    //
    // Delegating at document level + capture phase + stopImmediatePropagation
    // also makes this work after section_id AJAX swaps (where Empire's
    // button-bound handlers are gone because the buttons were re-rendered).
    var trigger = e.target.closest('[data-filter-group-trigger]');
    if (trigger) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var group = trigger.closest('.collection-filters__filter-group');
      var list = group && (group.querySelector('[data-filter-group-list]') ||
                           group.querySelector('.collection-filters__price-range-form'));
      // Determine current visible state from the DOM, not from aria-expanded.
      var isCurrentlyVisible = false;
      if (list) {
        var cs = window.getComputedStyle(list);
        isCurrentlyVisible = cs.display !== 'none';
      }
      var open = !isCurrentlyVisible;
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      trigger.classList.toggle('productgrid--sidebar-button-active', open);
      if (list) {
        list.classList.toggle('filter-group-active', open);
        list.setAttribute('data-accordion-state', open ? 'open' : 'closed');
        list.style.display = open ? '' : 'none';
      }
      return;
    }

    var link = e.target.closest(
      '.collection-filters__filter-link[data-filter-input], ' +
      '.active-filter-group__item, ' +
      '.filter-item-clear-all'
    );
    if (link) {
      var href = link.getAttribute('href');
      if (!href || href === '#') return;
      e.preventDefault();
      e.stopImmediatePropagation();
      navigate(href, sectionId);
      return;
    }

    // Sort dropdown options (built by collection-search.liquid)
    var sortBtn = e.target.closest('[data-sort-value]');
    if (sortBtn) {
      var value = sortBtn.getAttribute('data-sort-value');
      if (!value) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var url = new URL(location.href);
      url.searchParams.set('sort_by', value);
      navigate(url.pathname + url.search, sectionId);
      // Close the dropdown the way the inline handler would.
      var dd = document.querySelector('[data-sort-dropdown]');
      if (dd) dd.classList.remove('sort-dropdown--open');
      var t = document.querySelector('[data-sort-toggle]');
      if (t) t.classList.remove('sort-toggle--active');
      return;
    }
  }

  function navigate(url, id, skipPushState) {
    var u = new URL(url, location.origin);
    var sep = u.search ? '&' : '?';
    var fetchUrl = u.pathname + u.search + sep + 'section_id=' + id;

    // Capture pre-swap UI state so we can restore it after the section
    // innerHTML is replaced. The server renders the outer with
    // `sidebar--hidden` by default for collection pages — without this
    // capture/restore the sidebar would slam shut after every filter
    // click. Same idea for which filter groups the user has expanded.
    var preState = capturePreState();

    setLoading(true);

    fetch(fetchUrl, { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) {
        if (!r.ok) throw new Error('section fetch ' + r.status);
        return r.text();
      })
      .then(function (html) {
        // Section Rendering API returns just the section's inner HTML, not
        // a full document. Wrap it so we can query into it.
        var wrap = document.createElement('div');
        wrap.innerHTML = html;
        var oldSection = document.getElementById('shopify-section-' + id);
        if (!oldSection) throw new Error('section element missing');
        oldSection.innerHTML = wrap.innerHTML;

        // Empire's responsive-image lazy loader (rimg) only watches images
        // that exist at page-load time. After a section swap the new <img>
        // tags have no IntersectionObserver attached, so only the first
        // row (already in viewport) decodes — the rest stay blank until a
        // page refresh re-initializes the watcher. Empire exposes a jQuery
        // event 'theme:rimg:watch' that re-binds the watcher on a target.
        // Trigger it on the swapped section so all new images start loading.
        if (window.jQuery) {
          window.jQuery(oldSection).trigger('theme:rimg:watch');
        } else {
          oldSection.dispatchEvent(new CustomEvent('theme:rimg:watch', { bubbles: true }));
        }

        restorePreState(preState);

        if (!skipPushState) {
          history.pushState({ filterAjax: true }, '', url);
        }
        setLoading(false);
        // Smooth scroll so the new results land near the top, just under the
        // header. The product masthead is hidden on these pages (see brand-overrides.
        // css), so .collection-search-wrapper is the first visible content —
        // anchor on it, falling back to the grid if it's somehow absent. We
        // offset by the live header height + gap (see stickyHeaderOffset).
        // Keep the original guard: only scroll if the content has moved
        // meaningfully out of view, so we don't yank the page on small shifts.
        var anchor = document.querySelector('.collection-search-wrapper') || document.querySelector('[data-productgrid-items]');
        if (anchor) {
          var anchorTop = anchor.getBoundingClientRect().top + window.scrollY;
          var dest = Math.max(0, anchorTop - stickyHeaderOffset());
          if (window.scrollY > dest + 50) {
            window.scrollTo({ top: dest, behavior: 'smooth' });
          }
        }
      })
      .catch(function (err) {
        // On any failure, fall back to a normal navigation so the user
        // never gets stuck.
        console.error('[native-filter-ajax]', err);
        location.href = url;
      });
  }

  // Snapshot the sidebar's open/closed state and which filter groups the
  // user has expanded, so we can re-apply them after swapping the section.
  function capturePreState() {
    var outer = document.querySelector('[data-productgrid-outer]');
    var groups = document.querySelectorAll('.collection-filters__filter-group');
    var expanded = {};
    groups.forEach(function (g) {
      var title = g.querySelector('.collection-filters__filter-title');
      var trig = g.querySelector('[data-filter-group-trigger]');
      if (title && trig) {
        expanded[title.textContent.trim()] = trig.getAttribute('aria-expanded') === 'true';
      }
    });
    var sidebar = document.querySelector('.productgrid--sidebar');
    return {
      sidebarHidden: outer ? outer.classList.contains('sidebar--hidden') : true,
      expanded: expanded,
      sidebarScrollTop: sidebar ? sidebar.scrollTop : 0
    };
  }

  function restorePreState(state) {
    var outer = document.querySelector('[data-productgrid-outer]');
    if (outer) {
      outer.classList.toggle('sidebar--hidden', !!state.sidebarHidden);
      // The server renders an inline `style="display:none"` on the sidebar
      // for the initial load (before JS hydrates). After swap that inline
      // style comes back; clear it so CSS classes drive visibility.
      var sidebar = outer.querySelector('.productgrid--sidebar');
      if (sidebar) sidebar.style.display = '';
    }
    // Reapply each filter group's expand/collapse state. The group <ul>
    // uses `data-accordion-state="open|closed"` + class `filter-group-active`.
    var groups = document.querySelectorAll('.collection-filters__filter-group');
    groups.forEach(function (g) {
      var title = g.querySelector('.collection-filters__filter-title');
      if (!title) return;
      var key = title.textContent.trim();
      if (!(key in state.expanded)) return;
      var open = state.expanded[key];
      var trig = g.querySelector('[data-filter-group-trigger]');
      var list = g.querySelector('[data-filter-group-list]');
      if (trig) {
        trig.setAttribute('aria-expanded', open ? 'true' : 'false');
        trig.classList.toggle('productgrid--sidebar-button-active', open);
      }
      if (list) {
        list.classList.toggle('filter-group-active', open);
        list.setAttribute('data-accordion-state', open ? 'open' : 'closed');
        list.style.display = open ? '' : 'none';
      }
    });
    // Restore sidebar scroll so the user doesn't lose their place inside
    // the long Set facet.
    var sidebar = document.querySelector('.productgrid--sidebar');
    if (sidebar) sidebar.scrollTop = state.sidebarScrollTop || 0;
  }

  function setLoading(on) {
    var grid = document.querySelector('[data-productgrid-items]');
    if (grid) grid.style.opacity = on ? '0.5' : '';
    var sidebar = document.querySelector('[data-productgrid-sidebar]');
    if (sidebar) sidebar.style.pointerEvents = on ? 'none' : '';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
